import type { Prototype } from "../prototype-types";

export const marinaLiuPrototypes: Prototype[] = [
  {
    id: "insider-enrollment-payment-flow",
    name: "Insider enrollment payment flow",
    path: "/ml/insider-enrollment-payment-flow",
    description: "Funnel optimization for the Insider enrollment flow",
    owner: "Marina",
    createdAt: "2026-02-12",
    lastUpdated: "2026-02-13",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/fe4715d489a8e1fb41d322918c8aaadb592b227998a4a6576d543e3f4433ce09.png",
    figmaLink:
      "https://www.figma.com/design/zQ9xpEHdCqpuNjs2RtomLv/Insider-Enrollment-Tests?node-id=316-29084",
    creationTool: "cursor",
  },
  {
    id: "unified-progress-tracker",
    name: "Unified progress tracker",
    path: "/ml/unified-progress-tracker",
    description:
      "Exploring a concept combining the brand order minimum tracker with the Insider free shipping tracker.",
    owner: "Marina",
    createdAt: "2026-02-12",
    lastUpdated: "2026-02-12",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/cc36706833328c38144905565d3a7626c4bb70fceb9cf33eb381edd8b09659c2.png",
    figmaLink:
      "https://www.figma.com/design/xXa9iE4OGX8uJh8C6CkMeB/Unified-tracker-concept",
    creationTool: "cursor",
  },
];
